'use client';

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

interface ChatContextType {
    fetchLifeStyleImages: boolean;
    handleFetchLifeStyleImages: (value: boolean) => void;
    openChat: any;
    handleSetOpenChat: any
    currentTemplateDetails: any;
    handleCurrentTemplateDetails: (details: any) => void;
    currentLifeStyleImages: any;
    handleCurrentLifeStyleImages: (images: any) => void;
    selectedLifeStyleImageId: any;
    handleSelectedLifeStyleImageId: any
    isEditMode: boolean;
    handleSetIsEditMode: (value: boolean) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [currentTemplateDetails, setCurrentTemplateDetails] = useState<any>({});
    const [currentLifeStyleImages, setCurrentLifeStyleImages] = useState<any>([]);
    const [selectedLifeStyleImageId, setSelectedLifeStyleImageId] = useState<any>(null)
    const [fetchLifeStyleImages, setFetchLifeStyleImages] = useState<boolean>(false);
    //to know where it is opened from
    const [openChat, setOpenChat] = useState({ isOpen: false, from: '' });
    const handleFetchLifeStyleImages = useCallback((value: boolean) => {
        setFetchLifeStyleImages(value)
    }, [])
    const handleSetOpenChat = useCallback((val: any) => {
        setOpenChat(prevState => ({ ...prevState, ...val }))
    }, [])
    const handleCurrentTemplateDetails = useCallback((details: any) => {
        setCurrentTemplateDetails(details);
    }, []);
    const handleCurrentLifeStyleImages = useCallback((images: any) => {
        setCurrentLifeStyleImages(images);
    }, []);
    const handleSelectedLifeStyleImageId = useCallback((id: any) => {
        setSelectedLifeStyleImageId(id)
    }, [])
    const handleSetIsEditMode = useCallback((value: boolean) => {
        setIsEditMode(value);
    }, []);

    //effects
    useEffect(() => {
        if (!openChat?.isOpen) {
            setSelectedLifeStyleImageId(false);
            setIsEditMode(false);
        }
    }, [openChat?.isOpen])
    return (
        <ChatContext.Provider value={{
            isEditMode, handleSetIsEditMode, selectedLifeStyleImageId, handleSelectedLifeStyleImageId, currentTemplateDetails,
            handleCurrentTemplateDetails, currentLifeStyleImages, handleCurrentLifeStyleImages, fetchLifeStyleImages, handleFetchLifeStyleImages, openChat, handleSetOpenChat
        }}>
            {children}
        </ChatContext.Provider>
    );
};

export const useChat = () => {
    const context = useContext(ChatContext);
    if (!context) throw new Error('useChat must be used within a ChatProvider');
    return context;
};
